import { Component, Input, OnInit } from '@angular/core';
import { Route, Routes } from '@angular/router';
import { select, Store } from '@ngrx/store';
import Debug from 'debug';
import { Observable } from 'rxjs';
import { INavigationEvent } from '../../ngrx/aumico.layout.action';
import * as fromLayout from '../../ngrx/aumico.layout.reducer';
import { SubNavigationService } from './subnavigation.service';

const debug = Debug('aumico:aumico-core:SubnavigationComponent');

@Component({
    selector: 'aumico-subnavigation',
    templateUrl: './subnavigation.component.html',
    styleUrls: ['./subnavigation.component.scss'],
})
export class SubnavigationComponent implements OnInit {
    @Input() hide = false;
    subNavigation$: Observable<Routes>;
    activeSubNavigation$: Observable<Route>;

    constructor(
        private layoutStore: Store<fromLayout.ModuleState>,
        private subNavigationService: SubNavigationService,
    ) {}

    ngOnInit() {
        this.subNavigation$ = this.layoutStore.pipe(select(fromLayout.selectSubNavigation));
        this.activeSubNavigation$ = this.layoutStore.pipe(select(fromLayout.selectActiveSubNavigation));
    }

    onChangeTab(item: Route) {
        // TODO: this works now fine, but finally this should trigger a navigation in the router
        // then the routing event should dispatch this action.
        const event: INavigationEvent = {
            route: item,
        };
        debug(event);

        this.subNavigationService.onChangeTab(event);
    }
}
